import { render } from "./ManualAddBank.vue?vue&type=template&id=2a4b4d14&scoped=true"
import script from "./ManualAddBank.vue?vue&type=script&lang=js"
export * from "./ManualAddBank.vue?vue&type=script&lang=js"

import "./ManualAddBank.vue?vue&type=style&index=0&id=2a4b4d14&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a4b4d14"]])

export default __exports__